(function () {
  if (window.WillowFaucet) return;
  var VARS = {
    single: {
      wall: { id: '50441587425559', price: 0 },
      single: { id: '51481601933591', price: 15 },
      centerset: { id: '55121154965783', price: 45 },
      widespread: { id: '50441587949847', price: 45 }
    },
    double: {
      wall: { id: '50441587556631', price: 0 },
      single: { id: '50441587654935', price: 30 },
      centerset: { id: '55121155129623', price: 90 },
      widespread: { id: '50441587720471', price: 90 }
    }
  };
  var ADDON_IDS = {};
  Object.keys(VARS).forEach(function(sink){ Object.keys(VARS[sink]).forEach(function(key){ ADDON_IDS[VARS[sink][key].id] = true; }); });
  function icon(label) {
    var s = String(label == null ? '' : label).toLowerCase();
    if (!s) return null;
    if (s.indexOf('wall') >= 0) return 'wall';
    if (s.indexOf('centerset') >= 0 || s.indexOf('4') >= 0) return 'centerset';
    if (s.indexOf('widespread') >= 0 || s.indexOf('8') >= 0) return 'widespread';
    if (s.indexOf('single') >= 0) return 'single';
    return null;
  }
  function price(sink, ic, fallback) {
    var m = (VARS[sink] || {})[ic];
    if (!m) return fallback || '';
    return m.price > 0 ? '+$' + m.price : 'Included';
  }


  var queueKey = 'wvFaucetQueue';
  function readQueue(){ try { var q=JSON.parse(sessionStorage.getItem(queueKey)||'[]'); return Array.isArray(q)?q:[]; } catch (_) { return []; } }
  function saveQueue(q){ try { sessionStorage.setItem(queueKey,JSON.stringify(q)); } catch (_) {} }
  function push(entry){ saveQueue(readQueue().filter(function(e){return Date.now()-(e.at||0)<86400000;}).concat(entry)); }
  function group(item){ return item.properties && item.properties._grp || ''; }
  function addon(item){ return !!ADDON_IDS[String(item.variant_id||item.id)]; }
  function selectedService(item){
    if(addon(item)) return null;
    var props=item.properties||{}, key=icon(props['Faucet Drilling']);
    if(!key) return null;
    var explicit=String(props._wv_drilling_variant||'');
    if(ADDON_IDS[explicit]) return {id:explicit,label:props['Faucet Drilling']};
    var entry=VARS[/double/i.test((item.product_title||'')+' '+(item.title||''))?'double':'single'][key];
    return entry ? {id:entry.id,label:props['Faucet Drilling']} : null;
  }
  function attach(payload){
    var queue=readQueue(), extra=[];
    (payload.items||[]).forEach(function(parent){
      var entry=queue.find(function(e){return e.grp===group(parent);});
      if(!entry||!ADDON_IDS[String(entry.id)]) return;
      extra.push({id:entry.id,quantity:Number(parent.quantity)||1,parent_id:parent.id,properties:{Configuration:entry.label,'Faucet for':entry.vt,_grp:entry.grp}});
    });
    if(!extra.length) return false;
    payload.items=payload.items.concat(extra); return true;
  }
  function plan(cart){
    var items=cart.items||[], updates={}, additions=[], used=new Set();
    var parents=items.filter(function(item){return selectedService(item);});
    parents.forEach(function(parent){
      var service=selectedService(parent), grp=group(parent), desired=parent.quantity;
      var matches=items.filter(function(item){
        if(!addon(item)||used.has(item.key)||String(item.variant_id||item.id)!==String(service.id)) return false;
        var parentKey=item.parent_relationship && item.parent_relationship.parent_key;
        return parentKey ? parentKey===parent.key : grp ? group(item)===grp : !group(item);
      });
      var remaining=desired;
      matches.forEach(function(item){
        used.add(item.key);
        if(!item.parent_relationship?.parent_key){ updates[item.key]=0; return; }
        var qty=Math.min(remaining,item.quantity); remaining-=qty;
        if(qty!==item.quantity) updates[item.key]=qty;
      });
      if(remaining>0){
        if(matches.some(item=>item.parent_relationship?.parent_key)){var linked=matches.find(item=>item.parent_relationship?.parent_key);updates[linked.key]=(updates[linked.key]===undefined?linked.quantity:updates[linked.key])+remaining;}
        else additions.push({id:service.id,quantity:remaining,parent_line_key:parent.key,properties:{Configuration:service.label,'Faucet for':parent.product_title||parent.title,_grp:grp||('legacy-'+parent.key)}});
      }
    });
    items.filter(addon).forEach(function(item){if(!used.has(item.key)) updates[item.key]=0;});
    return {updates:updates,additions:additions};
  }
  var root=function(){return (window.Shopify && Shopify.routes && Shopify.routes.root || '/').replace(/\/?$/,'/');};
  async function request(path,body){
    var response=await fetch(root()+path,{method:body?'POST':'GET',credentials:'same-origin',headers:{'Content-Type':'application/json',Accept:'application/json'},body:body?JSON.stringify(body):undefined});
    var data=await response.json();if(!response.ok||data.status||data.errors)throw new Error(data.description||data.errors||'Cart update failed');return data;
  }
  var work=Promise.resolve();
  function reconcile(options){
    options=options||{};
    work=work.catch(function(){}).then(async function(){
      var cart=await request('cart.js'), changed=false;
      for(var pass=0;pass<3;pass++){
        var actions=plan(cart);
        if(!Object.keys(actions.updates).length&&!actions.additions.length) break;
        if(Object.keys(actions.updates).length) await request('cart/update.js',{updates:actions.updates});
        if(actions.additions.length){
          cart=await request('cart.js');actions=plan(cart);
          if(actions.additions.length)await request('cart/add.js',{items:actions.additions});
        }
        changed=true;cart=await request('cart.js');
      }
      var groups=new Set(cart.items.filter(function(i){return !addon(i);}).map(group));
      saveQueue(readQueue().filter(function(e){return !groups.has(e.grp)&&Date.now()-(e.at||0)<60000;}));
      if(changed||options.sections){
        var sections=options.sections||[];
        if(!sections.length) document.documentElement.dispatchEvent(new CustomEvent('cart:bundled-sections',{bubbles:true,detail:{sections:sections}}));
        if(sections.length){var response=await fetch(root()+'?sections='+encodeURIComponent([...new Set(sections)].join(',')));cart.sections=await response.json();}
        if(changed&&!options.silent){
          window.theme?.pubsub?.publish(theme.pubsub.PUB_SUB_EVENTS.cartUpdate,{source:'willow-faucet',cart:cart});
        }
      }
      return cart;
    });
    return work;
  }
  var scheduled;
  function schedule(){clearTimeout(scheduled);scheduled=setTimeout(function(){reconcile().catch(function(error){console.error('[willow] faucet reconcile failed:',error.message);});},150);}
  window.WillowFaucet={VARS:VARS,icon:icon,price:price,push:push,attach:attach,plan:plan,reconcile:reconcile};
  document.addEventListener('ajaxProduct:added',schedule);
  if(window.theme?.pubsub)theme.pubsub.subscribe(theme.pubsub.PUB_SUB_EVENTS.cartUpdate,function(event){if(event.source!=='willow-faucet')schedule();});
  ['cart:refresh','cart:updated','cart:open'].forEach(function(name){document.addEventListener(name,schedule);});
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',schedule);else schedule();
})();
